export default {
  DISTRIBUTE_RECURRENT_BALANCE_COMMAND: Symbol.for('DISTRIBUTE_RECURRENT_BALANCE_COMMAND'),
  DISTRIBUTE_RECURRENT_BALANCE_REPOSITORY: Symbol.for('DISTRIBUTE_RECURRENT_BALANCE_REPOSITORY'),
};
